/** Helpers for Recharts 3 — avoids DecimalError when domain/ticks get undefined. */

export function toChartNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function sanitizeMonthlyCompanyCounts(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row, i) => ({
    month: row?.month != null ? String(row.month) : `M${i + 1}`,
    count: toChartNumber(row?.count),
  }));
}

/** Always returns [0, positiveNumber] — never undefined (required for Recharts 3 tick math). */
export function numericAxisDomain(data, dataKey) {
  if (!Array.isArray(data) || data.length === 0) return [0, 1];
  const max = data.reduce((acc, row) => Math.max(acc, toChartNumber(row?.[dataKey])), 0);
  return [0, Math.max(max, 1)];
}
